import * as actions from '../constants/actions'
import { createReducer } from '../utils/redux'
import * as basemaps from '../constants/basemaps'

export default createReducer(basemaps.TOPOWEBB, {

    [actions.CHANGE_BASEMAP]: (state, action) => action.map

})



// WEBPACK FOOTER //
// ./src/reducers/basemap.js